import {AfterViewInit, Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Output, SimpleChanges, ViewChild} from '@angular/core';
import {MapService} from '@shared/services/map.service';
import {DatosMapaModel} from '@shared/models/datos-mapa.model';

@Component({
  selector: 'az-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  providers: [MapService]
})
export class MapComponent implements AfterViewInit, OnChanges, OnDestroy {

  @ViewChild('map') map: ElementRef<HTMLElement>;

  @Input() classes = '';
  @Input() data: DatosMapaModel[] = [];
  @Input() autoCenter = true;
  @Output() renderedMap = new EventEmitter<MapComponent>();

  constructor(public mapService: MapService) {}

  ngAfterViewInit(): void {
    this.mapService.createMap(this.map);
    this.renderMap();
  }

  ngOnDestroy(): void {
    this.mapService.destroyMap();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.map && changes.data) {
      this.renderMap();
    }
  }

  renderMap(): void {
    const validData = this.filterData(this.data || []);
    const dataAtRenderStart = this.data;

    this.mapService.render(validData).then((rendered) => {
      if (!rendered || dataAtRenderStart !== this.data) {
        return;
      }
      if (this.autoCenter) {
        this.mapService.fitBounds(validData);
      }
      this.renderedMap.emit(this);
    }).catch(() => this.renderedMap.emit(this));
  }

  invalidateSize(): void {
    this.mapService?.invalidateSize();
  }

  centerMapByData(): void {
    this.mapService.fitBounds(this.filterData(this.data || []));
  }

  private filterData(data: DatosMapaModel[]): DatosMapaModel[] {
    return data.filter((dato) => this.validateCoordinates(dato));
  }

  validateCoordinates(data: DatosMapaModel): boolean {
    const coordinates = data?.coordenadas;

    return !!coordinates
      && coordinates.x !== null
      && coordinates.x >= -90
      && coordinates.x <= 90
      && coordinates.y !== null
      && coordinates.y >= -180
      && coordinates.y <= 180;
  }

}
